export const HandleClickRowActive = (event: any, record: any) => {
  event.target.parentElement.classList.toggle('is-active');
};
